import { useState } from 'react'

export const usePromotionCodes = ({
    promotionCodes,
    calculatePreview,
    onChange,
    t,
}) => {
    const [promotionCodeInput, setPromotionCodeInput] = useState('')
    const [promotionError, setPromotionError] = useState(null)

    const applyPromotionCodes = async (nextPromotionCodes) => {
        let result

        try {
            result = await calculatePreview(nextPromotionCodes)
        } catch (error) {
            result = {
                status: false,
                message: t('promotion-validation-error'),
            }
        }

        if (!result || !result.status) {
            setPromotionError(
                result && result.message
                    ? result.message
                    : t('promotion-validation-error'),
            )

            return false
        }

        onChange(
            nextPromotionCodes,
            result.promotions,
        )

        setPromotionError(null)

        return true
    }

    const addPromotionCode = async () => {
        const code = promotionCodeInput.trim().toUpperCase()

        if (!code) {
            return
        }

        if (promotionCodes.includes(code)) {
            setPromotionError(
                t('promotion-code-already-added'),
            )
            setPromotionCodeInput('')

            return
        }

        await applyPromotionCodes([
            ...promotionCodes,
            code,
        ])

        setPromotionCodeInput('')
    }

    const removePromotionCode = async (code) => {
        await applyPromotionCodes(
            promotionCodes.filter(
                (promotionCode) => promotionCode !== code,
            ),
        )
    }

    return {
        promotionCodeInput,
        setPromotionCodeInput,
        promotionError,
        addPromotionCode,
        removePromotionCode,
    }
}
